// Audio player constants and configuration

export const AUDIO_CONFIG = {
  CACHE_SIZE_LIMIT: 50,
  THROTTLE_MS: 1000, // Only update parent every second
  TOLERANCE_EPS: 0.25, // 250ms tolerance for buffered range
  SKIP_SECONDS: 5,
  PLAYBACK_SPEEDS: [1, 1.25, 1.5, 2],
  SEEK_WINDOW_SECONDS: 30, // Try to seek within current stream if within 30 seconds
  SEEK_DEBOUNCE_MS: 200, // Debounce timeline seeking
  SEEK_DELAY_MS: 150, // Delay for rapid seeking
  ANIMATION_FRAME_THROTTLE: 0.1, // Only redraw timeline if time changed by 100ms
};

export const ERROR_MESSAGES = {
  1: 'Aborted',
  2: 'Network error',
  3: 'Decoding error',
  4: 'Source not supported',
};
